import React, { Component } from "react";
import { TextField } from "reactackle";
import SelectDropdownForGrid from "../../FieldsComponents/SelectDropdown/SelectDropdownForGrid";
import { isMobile } from "react-device-detect";
import { IconSvg } from "reactackle-icons";
import MenuColumnsDataGrid from "./MenuColumnsDataGrid";

export default class MenuColumns extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        path: "",
        payload: this.props.data
      }
    };
  }

  getTableDropDown = (fieldVal, arrIndex) => {
    return (
      <div
        style={{
          paddingLeft: "1px",
          textAlign: "left",
          border: "1px solid gainsboro",
          height: "45px"
        }}
      >
        <SelectDropdownForGrid
          title={"Title"}
          data={this.getAvailableChoices()}
          label={"label"}
          placeholder={"placeholder"}
          value={
            fieldVal && fieldVal && fieldVal.menuCaption
              ? fieldVal.menuCaption
              : ""
          }
          stateFieldName={this.props.stateFieldName}
          isPayload={true}
          fieldName={"menu"}
          arrayIndex={arrIndex}
          stateHandler={(val, id, isPayload) => {
            this.props.tableSelectionHandler(val, arrIndex);
          }}
        />
      </div>
    );
  };

  getInputRecLimit = (fieldVal, arrIndex) => {
    return (
      <div
        style={{
          paddingLeft: "1px",
          textAlign: "right",
          border: "1px solid gainsboro",
          height: "45px",
          marginTop: "5px",
          marginBottom: "5px"
        }}
      >
        <TextField
          value={
            fieldVal && fieldVal.recLimit && fieldVal.recLimit !== undefined
              ? fieldVal.recLimit
              : ""
          }
          onChange={e => {
            this.props.limitHandler(e.value, "recLimit", arrIndex);
          }}
          fullWidth
          disabled={false}
          placeholder={" DESKTOP RECORDS LIMIT"}
        />
      </div>
    );
  };

  getInputMenuIcon = (fieldVal, arrIndex) => {
    return (
      <div
        style={{
          paddingLeft: "1px",
          textAlign: "right",
          border: "1px solid gainsboro",
          height: "45px",
          marginTop: "5px",
          marginBottom: "5px"
        }}
      >
        <TextField
          value={
            fieldVal && fieldVal.menuIcon && fieldVal.menuIcon !== undefined
              ? fieldVal.menuIcon
              : ""
          }
          onChange={e => {
            this.props.limitHandler(e.value, "menuIcon", arrIndex);
          }}
          fullWidth
          disabled={false}
          placeholder={"fa fa-home"}
        />
      </div>
    );
  };

  getInputMobileRecLimit = (fieldVal, arrIndex) => {
    return (
      <div
        style={{
          paddingLeft: "1px",
          textAlign: "right",
          border: "1px solid gainsboro",
          height: "45px",
          marginTop: "5px",
          marginBottom: "5px"
        }}
      >
        <TextField
          value={
            fieldVal &&
            fieldVal.recMobileLimit &&
            fieldVal.recMobileLimit !== undefined
              ? fieldVal.recMobileLimit
              : ""
          }
          onChange={e => {
            this.props.limitHandler(e.value, "recMobileLimit", arrIndex);
          }}
          fullWidth
          disabled={false}
          placeholder={"MOBILE RECORDS LIMIT"}
        />
      </div>
    );
  };

  getDisplayToggle = (fieldVal, arrIndex) => {
    return (
      <div
        style={{
          paddingLeft: "1px",
          textAlign: "left",
          border: "1px solid gainsboro",
          height: "45px",
          marginTop: "5px",
          marginBottom: "5px"
        }}
      >
        <SelectDropdownForGrid
          title={"Title"}
          data={[{ name: "YES", value: "YES" }, { name: "NO", value: "NO" }]}
          label={"label"}
          placeholder={"placeholder"}
          value={
            fieldVal && fieldVal.displayToggle ? fieldVal.displayToggle : ""
          }
          stateFieldName={"displayToggle"}
          isPayload={true}
          fieldName={"name"}
          arrayIndex={arrIndex}
          stateHandler={(val, id, isPayload) => {
            this.props.limitHandler(val, "displayToggle", arrIndex);
          }}
        />
      </div>
    );
  };

  getInputRows = () => {
    if (this.props.value && this.props.value.length > 0) {
      return this.props.value.map((val, arrIndex) => {
        return (
          <div
            style={{
              padding: "0px",
              textAlign: "left",
              border: "1px solid gainsboro",
              padding: "20px",
              paddingBottom: "0px",
              marginTop: "5px",
              marginBottom: "5px"
            }}
          >
            <table className="table table-striped">
              <tr>
                <td style={{ width: "45px" }}>{this.getDelIcon(arrIndex)}</td>
                <td style={{ width: "45px" }}>{this.getUpIcon(arrIndex)}</td>
                <td style={{ width: "45px" }}>{this.getDownIcon(arrIndex)}</td>
                <td style={{ width: "45px" }}>{this.getPlusIcon(arrIndex)}</td>
                <td>{this.getTableDropDown(val, arrIndex)}</td>
              </tr>
              <tr>
                <td colSpan={5}>{this.getDisplayToggle(val, arrIndex)}</td>
              </tr>
              <tr>
                <td colSpan={5}>{this.getInputRecLimit(val, arrIndex)}</td>
              </tr>
              <tr>
                <td colSpan={5}>{this.getInputMenuIcon(val, arrIndex)}</td>
              </tr>
              <tr>
                <td colSpan={5}>
                  {this.getInputMobileRecLimit(val, arrIndex)}
                </td>
              </tr>
              <tr>
                <td
                  colSpan={5}
                  style={{
                    maring: "10px"
                  }}
                >
                  {this.getDataRows(val, arrIndex)}
                </td>
              </tr>
            </table>
          </div>
        );
      });
    }
  };

  getDataRows = (val, arrIndex) => {
    return (
      <MenuColumnsDataGrid
        fieldsList={this.props.listOfTables}
        stateFieldName={"dataConditions"}
        value={
          val && val.dataConditions && val.dataConditions !== undefined
            ? val.dataConditions
            : []
        }
        stateChangeHandler={this.dataGridStateChangeHandler}
        isPayload={true}
        title={"MENU LIST"}
        arrIndex={arrIndex}
        recLimitFieldVal={"fieldVal"}
        recLimitFieldName={"fieldName"}
        emptyRow={{ fieldName: "", fieldVal: "" }}
        createTableList={this.props.createTableList}
        tableName={
          val && val.tableName && val.tableName !== undefined
            ? val.tableName
            : ""
        }
        fullFieldVal={val}
        // otherFields={[
        //   { src: "name", tgt: "name" },
        //   { src: "tableName", tgt: "tableName" }
        // ]}
      />
    );
  };

  dataGridStateChangeHandler = (fullDataGridVal, arrIndex) => {
    //console.log("fullDataGridVal: " + JSON.stringify(fullDataGridVal));
    let array = _.cloneDeep(this.props.value);
    array[arrIndex]["dataConditions"] = fullDataGridVal;

    this.props.stateChangeHandler(
      array,
      this.props.stateFieldName,
      this.props.isPayload
    );

    this.props.stateChangeHandler;
  };

  move = (oldIndex, newIndex) => {
    let array = _.cloneDeep(this.props.value);
    //console.log("before: " + JSON.stringify(array));
    if (newIndex >= array.length) {
      newIndex = array.length - 1;
    }
    array.splice(newIndex, 0, array.splice(oldIndex, 1)[0]);
    //console.log("after: " + JSON.stringify(array));
    this.props.stateChangeHandler(
      array,
      this.props.stateFieldName,
      this.props.isPayload
    );
  };

  getDelIcon = rowNum => {
    return (
      <div
        style={{
          padding: "10px",
          textAlign: "center",
          border: "1px solid gainsboro",
          height: "45px",
          width: "45px"
        }}
      >
        <a
          onClick={() => {
            this.itemDeleteHandler(rowNum);
          }}
        >
          <IconSvg>
            <svg style={{ width: "24px", height: "24px" }} viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19M8,9H16V19H8V9M15.5,4L14.5,3H9.5L8.5,4H5V6H19V4H15.5Z"
              />
            </svg>
          </IconSvg>
        </a>
      </div>
    );
  };

  getUpIcon = rowNum => {
    return (
      <div
        className="col-sm-2"
        style={{
          padding: "10px",
          textAlign: "center",
          border: "1px solid gainsboro",
          height: "45px",
          width: "45px"
        }}
      >
        <a
          onClick={() => {
            this.move(rowNum, rowNum - 1);
          }}
        >
          <IconSvg>
            <svg style={{ width: "24px", height: "24px" }} viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M16,13V21H8V13H2L12,3L22,13H16M7,11H10V19H14V11H17L12,6L7,11Z"
              />
            </svg>
          </IconSvg>
        </a>
      </div>
    );
  };
  getDownIcon = rowNum => {
    return (
      <div
        className="col-sm-2"
        style={{
          padding: "10px",
          textAlign: "center",
          border: "1px solid gainsboro",
          height: "45px",
          width: "45px"
        }}
      >
        <a
          onClick={() => {
            this.move(rowNum, rowNum + 1);
          }}
        >
          <IconSvg>
            <svg style={{ width: "24px", height: "24px" }} viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M22,11L12,21L2,11H8V3H16V11H22M12,18L17,13H14V5H10V13H7L12,18Z"
              />
            </svg>
          </IconSvg>
        </a>
      </div>
    );
  };

  getPlusIcon = rowNum => {
    return (
      <div
        style={{
          padding: "10px",
          textAlign: "center",
          border: "1px solid gainsboro",
          height: "45px",
          width: "45px"
        }}
      >
        <a
          href="_"
          onClick={event => {
            event.preventDefault();
            this.itemAddHandler(rowNum);
          }}
        >
          <IconSvg>
            <svg style={{ width: "24px", height: "24px" }} viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"
              />
            </svg>
          </IconSvg>
        </a>
      </div>
    );
  };

  itemUpdateHandler = (rowNum, newVal) => {
    //console.log("rowNum: " + rowNum + " updated: " + newVal);

    let tmpData = _.cloneDeep(this.props.value);
    //console.log("Before: " + JSON.stringify(tmpData[rowNum]));
    tmpData[rowNum][this.props.fieldNameInArray] = newVal;
    //console.log("After: " + JSON.stringify(tmpData[rowNum]));

    this.props.stateChangeHandler(
      tmpData,
      this.props.stateFieldName,
      this.props.isPayload
    );
  };

  itemAddHandler = rowNum => {
    //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));
    let tmpData = _.cloneDeep(this.props.value);
    //console.log("Before: " + JSON.stringify(tmpData));
    tmpData.splice(rowNum + 1, 0, this.props.emptyRow);

    //console.log("After: " + JSON.stringify(tmpData));
    this.props.stateChangeHandler(
      tmpData,
      this.props.stateFieldName,
      this.props.isPayload
    );
  };

  itemDeleteHandler = rowNum => {
    //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));
    let tmpData = _.cloneDeep(this.props.value);
    //console.log("Before: " + JSON.stringify(tmpData));
    delete tmpData[rowNum];

    tmpData = tmpData.filter(item => item !== null);
    //console.log("at filter:" + JSON.stringify(currActionsList));

    this.props.stateChangeHandler(
      tmpData,
      this.props.stateFieldName,
      this.props.isPayload
    );
  };

  getSelectionList = () => {
    return (
      <div
        className="row"
        style={{
          marginLeft: "1px",
          marginRight: "1px",
          alignItems: "center",
          padding: "2px",
          border: "0px solid gainsboro",
          borderStyle: "solid",
          paddingBottom: isMobile ? "0px" : "2px"
        }}
      >
        <div
          className="col-sm-2 align-self-center”"
          style={{
            margin: "0px",
            verticalAlign: "middle",
            height: "auto",
            padding: "0px"
          }}
        >
          <div
            style={{
              marginTop: isMobile ? "13px" : "0px",
              verticalAlign: "middle",
              lineHeight: isMobile ? "20px" : "37px",
              padding: "0px",
              paddingRight: "2px",
              color: "grey",
              marginBottom: isMobile ? "-1px" : "0px",
              textAlign: "left",
              fontSize: "10px"
            }}
          >
            {"Select to Add"}
          </div>
        </div>
        <div
          className="col-sm-10"
          style={{
            padding: "0px",
            textAlign: "left",
            border: "1px solid gainsboro"
          }}
        ></div>
      </div>
    );
  };

  getAvailableChoices = () => {
    let availableChoices = [];
    if (this.props.fieldsList && this.props.fieldsList.length > 0) {
      for (let i = 0; i < this.props.fieldsList.length; i++) {
        //console.log("~ " + this.props.fieldsList[i].name);
        if (!this.props.value.includes(this.props.fieldsList[i].menu)) {
          //console.log("~ included - " + this.props.fieldsList[i].name);
          availableChoices.push(this.props.fieldsList[i]);
        } else {
          //console.log("~ excluded - " + this.props.fieldsList[i].name);
        }
      }
    }
    return availableChoices;
  };

  render() {
    return (
      <div
        className="row"
        style={{
          marginLeft: "1px",
          marginRight: "1px",
          alignItems: "center",
          padding: "2px",
          border: "0px solid gainsboro",
          paddingBottom: isMobile ? "0px" : "2px"
        }}
      >
        <div
          className="col-sm-4 align-self-center”"
          style={{
            margin: "0px",
            verticalAlign: "middle",
            height: "auto",
            padding: "0px"
          }}
        >
          <div
            style={{
              marginTop: isMobile ? "13px" : "0px",
              verticalAlign: "middle",
              lineHeight: isMobile ? "20px" : "37px",
              padding: "0px",
              color: isMobile ? "grey" : "black",
              marginBottom: isMobile ? "-1px" : "0px"
            }}
          >
            {this.props.title}
          </div>
        </div>
        <div
          className="col-sm-8"
          style={{
            padding: "0px",
            textAlign: "left",
            border: "0px solid gainsboro",
            padding: "0px"
          }}
        >
          {this.getInputRows()}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/Screens/ControlEngine/StaticList/MenuColumns.jsx